import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=f7a1de5c&scoped=true&"
import script from "./Gifts.vue?vue&type=script&lang=js&"
export * from "./Gifts.vue?vue&type=script&lang=js&"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=f7a1de5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7a1de5c",
  null
  
)

export default component.exports